const ActionSection = () => {
  return (
    <div className="py-16 px-4">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            How SeniorThrive Works
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Three simple steps to take control of your home safety and independence.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-md p-8 text-center relative overflow-hidden">
            <div className="absolute top-0 right-0 w-24 h-24 rounded-bl-full"></div>
            <div className="w-16 h-16 bg-primary text-primary-foreground rounded-md flex items-center justify-center mx-auto mb-6 font-bold text-2xl shadow-raised">
              1
            </div>
            <h3 className="text-xl font-bold text-foreground mb-4">
              Assess & Understand
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              Complete a wellness assessment and use smart home safety checks 
              to identify risks before they become problems.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-secondary/50 to-accent/50 rounded-md p-8 text-center relative overflow-hidden">
            <div className="absolute top-0 right-0 w-24 h-24 rounded-bl-full"></div>
            <div className="w-16 h-16 bg-primary text-primary-foreground rounded-md flex items-center justify-center mx-auto mb-6 font-bold text-2xl shadow-raised">
              2
            </div>
            <h3 className="text-xl font-bold text-foreground mb-4">
              Get Personalized Guidance
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              Receive actionable recommendations, DIY fixes, and local service 
              providers tailored to your specific needs.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-md p-8 text-center relative overflow-hidden">
            <div className="absolute top-0 right-0 w-24 h-24 rounded-bl-full"></div>
            <div className="w-16 h-16 bg-primary text-primary-foreground rounded-md flex items-center justify-center mx-auto mb-6 font-bold text-2xl shadow-raised">
              3
            </div>
            <h3 className="text-xl font-bold text-foreground mb-4">
              Stay Connected & Supported
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              Coordinate care with family, track progress with ThriveScore, 
              and connect with a supportive community.
            </p>
          </div>
        </div>
        
        <div className="bg-gradient-to-br from-primary/10 to-primary-glow/15 border border-primary/30 rounded-lg p-8 text-center shadow-raised hover:shadow-overlay transition-all duration-300">
          <h3 className="text-xl font-bold text-foreground mb-4">
            The Result: You Stay in Control
          </h3>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            One comprehensive platform that helps you thrive at home with confidence, 
            safety, and independence, no more fragmented solutions or emergency waiting.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ActionSection;